import { render, staticRenderFns } from "./peoplelist.vue?vue&type=template&id=54177987&scoped=true&"
import script from "./peoplelist.vue?vue&type=script&lang=js&"
export * from "./peoplelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54177987",
  null
  
)

export default component.exports